import moment from 'moment';
import { DateType } from 'api/models';
import { ProjectFinancialsDateRange } from 'api/project';
import { numberFormatter } from 'components/atoms/currency-renderer';
import { defaultFormat } from 'utils/date-field/formatter';
import { FinancialsZoomLevel } from '../types/common';

export const hoursToMins = (hours: number): number => hours * 60;

export const minsToHours = (hours: number): number =>
  numberFormatter(hours / 60);

export const percentageRenderer = (value: number | string): string =>
  `${value}%`;

export const getFilteredZoomLevels = (
  zoomLevels: FinancialsZoomLevel[],
  startDate?: DateType,
  endDate?: DateType,
): FinancialsZoomLevel[] => {
  if (startDate == null || endDate == null) {
    return [];
  }

  let monthCount = 0;
  let currDate = defaultFormat(moment(startDate).startOf('month'));

  while (moment(currDate).isSameOrBefore(moment(endDate))) {
    monthCount += 1;
    currDate = defaultFormat(moment(currDate).add(1, 'month'));
  }

  return zoomLevels.filter(
    (zoomLevel) =>
      monthCount >= 6 || zoomLevel !== FinancialsZoomLevel.Quarterly,
  );
};

export const getDateCategoriesBasedOnDuration = (
  { startDate, endDate }: ProjectFinancialsDateRange,
  zoomLevel: FinancialsZoomLevel,
): DateType[] => {
  const columns: DateType[] = [];

  if (startDate == null || endDate == null) {
    return [];
  }

  if (zoomLevel === FinancialsZoomLevel.Overall) {
    return [startDate];
  }

  if (zoomLevel === FinancialsZoomLevel.Period) {
    // TODO: handle periodic columns
    return [];
  }

  let currDate =
    zoomLevel === FinancialsZoomLevel.Monthly
      ? startDate
      : defaultFormat(moment(startDate).startOf('quarter'));

  while (moment(currDate).isSameOrBefore(moment(endDate))) {
    columns.push(currDate);
    currDate = defaultFormat(
      moment(currDate).add(
        1,
        zoomLevel === FinancialsZoomLevel.Monthly ? 'month' : 'quarter',
      ),
    );
  }

  return columns;
};
